import { render } from "./FlagCheckeredIcon.vue?vue&type=template&id=31535878"
import script from "./FlagCheckeredIcon.vue?vue&type=script&lang=js"
export * from "./FlagCheckeredIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__